// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__8trXu","scaledWrapper":"dashboard_scaledWrapper__u2TLj","stickyHeader":"dashboard_stickyHeader__v82jc","main":"dashboard_main__5Iju2"};